/**
 * Where an onboarding milestone is done in the admin app.
 *
 * Onboarding emails link to `/go/onboarding/{milestone}?org={organizationId}`. The API's
 * `AdoptionStepLinks` (api/src/AdaptiveCatalog.Api.BusinessLogic/Adoption/AdoptionStepLinks.cs) builds
 * those links, and the milestone ids come from `AdoptionMilestones.cs`. The destinations mirror the
 * Getting Started checklist CTAs in components/GettingStarted/GettingStartedButton.tsx, so an email
 * lands exactly where the in-app checklist would send the same person.
 */
export const ONBOARDING_FALLBACK_PATH = '/';

const ONBOARDING_STEP_PATHS: Record<string, string> = {
    'organization-created': '/',
    'first-login': '/',
    'distributor-connected': '/settings/extensions?distributorSetup=1',
    'products-in-catalog': '/search',
    'first-search': '/search',
    'first-saved-search': '/search',
    'crm-connected': '/settings/extensions?crmSetup=1',
    'storefront-created': '/settings/storefront/storefronts',
    'storefront-built-with-ai': '/settings/storefront/storefronts',
    'storefront-published': '/settings/storefront/storefronts',
    // Inviting customers is per storefront (needs a storefront id), so the list is the entry point.
    'first-customer-invited': '/settings/storefront/storefronts',
    'first-order': '/storefront/orders',
    'customers-ordering': '/storefront/orders',
};

export const getOnboardingStepPath = (milestone?: string): string =>
    (milestone && Object.prototype.hasOwnProperty.call(ONBOARDING_STEP_PATHS, milestone)
        ? ONBOARDING_STEP_PATHS[milestone]
        : undefined) ?? ONBOARDING_FALLBACK_PATH;
